import { TweetProcessed } from 'data/twitter/types'
import Message from 'components/Message'
import styles from './ConversationContent.module.css'
import { TwitterTweetLink } from 'components/Message/Message'
import TwitterIcon from 'components/Icons/Twitter'
import { isNil } from 'lodash'
// import { Conversation } from 'data/conversations/types'

type Props = {
  primary?: TweetProcessed,
  replies: TweetProcessed[],
  collapseReplies?: boolean,
  // conversation?: Conversation,
  conversationId?: string,
  suppressTweetLinks?: boolean,
}

const ConversationContent = ({
  primary,
  replies,
  collapseReplies = false,
  conversationId,
  suppressTweetLinks = false,
}: Props) => {
  // TODO: add blog user ID's to blogSettings, then set isAuthor based on that? Or add author ID to blogpost
  // console.log('CONVERSATION CONTENT', replies)
  const externalId = primary?.external_id
  const authorUsername = primary?.author_username
  const isAuthor = (thisAuthorId: string) =>
        thisAuthorId === primary?.author_id
  const isPrimaryEnabled =
    isNil(primary?.tweetConversations?.[0]?.isEnabled)
      ? true
      : primary?.tweetConversations?.[0]?.isEnabled
  return <div className={styles.conversationContent}>
    { primary && <div className={ isPrimaryEnabled ? styles.parentTweet : styles.parentTweetHidden }>
      { !!externalId && !!authorUsername && <div className={styles.twitterLink}>
        {
          suppressTweetLinks
            ? <TwitterIcon width={24} height={24} />
            : <TwitterTweetLink conversationId={ externalId } username={ authorUsername }>
              <TwitterIcon width={24} height={24} />
            </TwitterTweetLink>
        }
      </div> }
      <Message
        message={primary}
        isAuthor={isAuthor}
        conversationId={conversationId}
      />
    </div> }
    { !collapseReplies && <div className={styles.replies}>
      { replies
        ?.filter(reply => reply.reply_to_id === primary?.external_id)
        ?.sort((a, b) =>
          (a?.external_id || 0) > (b?.external_id || 0)
            ? 1
            : -1
        )
        ?.map(reply =>
          <div key={reply.id} className={styles.replyContainer}>
            <Message
              message={reply}
              isAuthor={isAuthor}
              parent={primary}
              replies={replies}
              conversationId={conversationId}
            />
          </div>
        )
      }
    </div> }
  </div>
}

export default ConversationContent
